import type { CSSProperties } from 'react';
import type { GridLayout } from '../../store/flashbackStore/dashboardStore.ts';

const COL_COUNT: Record<GridLayout, number> = {
  '1x1': 1,
  '2x2': 2,
  '3x3': 3,
  '4x4': 4,
};

const MIN_ROW_HEIGHT_PX: Record<GridLayout, number> = {
  '1x1': 520,
  '2x2': 400,
  '3x3': 300,
  '4x4': 240,
};

export interface GridLayoutResult {
  style: CSSProperties;
  /** When true, cells expand to fill the scrollport (dense grid). */
  fillCells: boolean;
}

/**
 * Grid sizing for the live camera wall.
 * Only allocates rows for cameras that exist; avoids empty rows that force scroll.
 */
export function gridStyleFor(layout: GridLayout, itemCount: number): GridLayoutResult {
  const cols = COL_COUNT[layout];
  const rowsNeeded = Math.max(1, Math.ceil(itemCount / cols));
  const slotCount = cols * cols;
  const fillCells = itemCount > 0 && itemCount >= slotCount;
  const minRowPx = MIN_ROW_HEIGHT_PX[layout];
  const rowTrack = fillCells ? `minmax(${minRowPx}px, 1fr)` : 'auto';

  return {
    fillCells,
    style: {
      gridTemplateColumns: `repeat(${cols}, minmax(0, 1fr))`,
      gridTemplateRows: `repeat(${rowsNeeded}, ${rowTrack})`,
      gridAutoRows: fillCells ? rowTrack : `minmax(0, auto)`,
    },
  };
}
